export default {
  index: [
    {
      path: '/processtemplate',
      component: resolve => require(['./processtemplateIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/process_template/_router.js